import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import "./index.scss";

const PanelWrapper = ({ children, label, color }) => {
  let colorClass = "";
  switch (color) {
    case "black":
      colorClass = "-black";
      break;
    default:
  }
  return (
    <div className={cx("panel-wrapper", { [`${colorClass}`]: true })}>
      {label ? <p className="panel-label">{label}</p> : ""}
      {children}
    </div>
  );
};

PanelWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
  color: PropTypes.string,
};

PanelWrapper.defaultProps = {
  label: "",
  color: "white",
};

export default PanelWrapper;
